module.exports = __webpack_public_path__ + "img/home.0fa4daf1.jpeg";